import {createSlice, PayloadAction} from '@reduxjs/toolkit'
import AddOrderModel from "../dto/order/AddOrderModel";

const initValue: AddOrderModel[] = []

export const orderSlice = createSlice({
    name: 'orderSlice',
    initialState: {
        value: initValue
    },
    reducers: {
        setOrders: (state, action: PayloadAction<AddOrderModel[]>) => {
            state.value = action.payload;
        },
        clearOrders: (state, action: PayloadAction) => {
            state.value = []
        },
        addOrder: (state, action: PayloadAction<AddOrderModel>) => {
            state.value.push(action.payload)
        },
        removeOrder: (state, action: PayloadAction<number>) => {
            const orderItem = state.value.map((item) => item.tempId).indexOf(action.payload)

            if (orderItem != -1){
                state.value.splice(orderItem, 1)
            }
        },
        updateOrder: (state, action: PayloadAction<AddOrderModel>) => {
            const orderItem = state.value.map((item) => item.tempId).indexOf(action.payload.tempId)

            if (orderItem != -1){
                state.value.splice(orderItem, 1, action.payload)
            }
        },
        updateSavedOrderAddress: (state, action: PayloadAction<{orderId: number, deliveryAddressId: number, paymentType: number | null}>) => {
            const orderItem = state.value.map((item) => item.tempId).indexOf(action.payload.orderId)

            if (orderItem != -1){
                state.value.splice(orderItem, 1,
                    {...state.value[orderItem],
                deliveryAddressId: action.payload.deliveryAddressId,
                deliveryAddress: null,
                paymentType: action.payload.paymentType,
                isPickup: false});
            }
        }
    }
})

export const {
    addOrder,
    removeOrder,
    clearOrders,
    updateOrder,
    setOrders,
    updateSavedOrderAddress,
} = orderSlice.actions

export default orderSlice.reducer